<template>
  <div id="logout" />
</template>

<script>
import { types } from '../store/rootTypes';

export default {
  name: 'Logout',
  async mounted() {
    await this.$store.dispatch(types.authentication.actions.logout);
    this.$router.push('/login');
  },
};
</script>

<style scoped></style>
